import {
  BankOutlined,
  FileTextOutlined,
  ShoppingOutlined,
  SwapOutlined,
  TeamOutlined,
  ToolOutlined,
  UserOutlined
} from "@ant-design/icons"
import React from "react"

import { FORM_ENTITY_NAV } from "./form-field-requirements.types.ts"

const ENTITY_ICONS: Record<string, React.ReactNode> = {
  lead: <UserOutlined />,
  project: <BankOutlined />,
  customer: <TeamOutlined />,
  subcontractor: <ToolOutlined />,
  invoice: <FileTextOutlined />,
  change_request: <SwapOutlined />,
  purchase_order: <ShoppingOutlined />
}

interface EntitySidebarProps {
  activeEntity: string
  onSelect: (entity: string) => void
}

export function EntitySidebar({ activeEntity, onSelect }: EntitySidebarProps) {
  return (
    <nav className="flex w-44 shrink-0 flex-col gap-0.5">
      {FORM_ENTITY_NAV.map((entity) => {
        const active = entity.key === activeEntity
        return (
          <button
            className={`flex items-center gap-2 rounded-md px-3 py-2 text-left text-sm transition-colors ${
              active
                ? "bg-primary/10 font-medium text-primary"
                : "text-gray-600 hover:bg-gray-50"
            }`}
            key={entity.key}
            onClick={() => onSelect(entity.key)}
            type="button"
          >
            <span className={active ? "text-primary" : "text-gray-400"}>
              {ENTITY_ICONS[entity.key]}
            </span>
            {entity.label}
          </button>
        )
      })}
    </nav>
  )
}
